<form (ngSubmit)="dialogRef.close()">
  <h1 mat-dialog-title>{{ titleKey | translate }}</h1>
  <div mat-dialog-content>
    <p>
      ⚠️&nbsp;<span>{{ descriptionKey | translate }}</span>
    </p>
    <ng-container *ngFor="let item of dependencies | keyvalue">
      <p>
        <span translate="parameters/quick-replies/agent-shortcuts/scenario-name"></span>:&nbsp;<strong>{{
          item.key
        }}</strong>
      </p>
      <ul>
        <li *ngFor="let dependency of dependencies[item.key]">
          <span translate="parameters/quick-replies/agent-shortcuts/template-name"></span>:&nbsp;<a
            [href]="dependency.url"
            rel="noopener noreferrer"
            target="_blank"
            >{{ dependency.template_name }}</a
          >
          <ul>
            <li *ngFor="let box of dependency.boxes">
              <span translate="parameters/quick-replies/agent-shortcuts/agent-shorcut"></span>:&nbsp;<a
                [href]="box.url"
                rel="noopener noreferrer"
                target="_blank"
                >{{ box.name }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </ng-container>
  </div>
  <div mat-dialog-actions>
    <button
      type="button"
      color="primary"
      mat-raised-button
      mat-button
      (click)="dialogRef.close()"
      translate="close"></button>
  </div>
</form>
